import { useTranslation } from 'react-i18next';
import { Button } from 'v5/design-system/Button';
import {
  formatAppCrashErrorLog,
  resolveAppCrashDashboardHref
} from 'v5/features/core/app-crash/formatAppCrashErrorLog';
import { FullPageDashboardLink } from 'v5/patterns/page-layout/FullPageDashboardLink';
import { FullPageErrorLog } from 'v5/patterns/page-layout/FullPageErrorLog';
import { FullPageStatusLayout } from 'v5/patterns/page-layout/FullPageStatusLayout';
import type { ServerFailurePayload } from 'v5/platform/server-unreachable/serverUnreachableEvent';

export type ServerUnreachableScreenProps = ServerFailurePayload & {
  className?: string;
};

export function ServerUnreachableScreen({
  error,
  variant,
  kind,
  className
}: ServerUnreachableScreenProps) {
  const { t } = useTranslation('core', { keyPrefix: 'server_unreachable' });
  const { display, clipboard } = formatAppCrashErrorLog(error);
  const dashboardHref = resolveAppCrashDashboardHref();

  return (
    <FullPageStatusLayout
      idPrefix="server-unreachable"
      className={className}
      title={t(`${variant}.title`)}
      description={t(`${variant}.description_${kind}`)}
      actions={
        <>
          <Button
            type="button"
            variant="primary"
            size="md"
            onClick={() => window.location.reload()}
          >
            {t('refresh')}
          </Button>
          {dashboardHref ? (
            <FullPageDashboardLink href={dashboardHref}>
              {t('goToDashboard')}
            </FullPageDashboardLink>
          ) : null}
        </>
      }
    >
      <FullPageErrorLog
        label={t('errorLogLabel')}
        display={display}
        clipboard={clipboard}
      />
    </FullPageStatusLayout>
  );
}
